import Utils from "./utils.class";

const {jQuery: $} = window;

export default class NavBar {
    #$header;
    #$nav;
    #$menuItem;
    #$submenus;
    #utils;

    constructor(utils) {
        this.#utils = utils;
        this.#$header = $(".menu-elements__tab-row");
        this.#$nav = this.#$header.find(".menu-elements__tab-row");
        this.#$menuItem = this.#$header.find('.menu-elements__tab-group-wrap');
        this.#$submenus = this.#$header.find('.menu-elements__tabRowContainer');
    }

    events() {
        const me = this;
        // height variable for stytling
        $(".menu-elements__tab-row").each(function () {

            // Pull the Menu items out and put them in the content container
            me.#$menuItem.each(function () {
                const $dataAtt = $(this).data('box'); //Grab Unique identifier
                $(this).children(".sub-menu")[0].dataset.content = ($dataAtt) //Add unique identifier to submenu

                $(this).children(".sub-menu")[0].className += " menu-elements__tabRowContent" //Add unique class to submenu
                $(".menu-elements__tabRowContainer").append($(this).children(".sub-menu")[0])
            });

            Utils.equalHeight('.menu-elements__tabRowContent', '.menu-elements__tabRowContainer');
            Utils.equalHeight('.menu-elements__tab-group', '.menu-elements__tab-row > .sub-menu');

            //
            $(this).find(".menu-elements__tab-group").first().addClass("js-active");
            $(this).find(".menu-elements__tabRowContent").first().addClass("js-active");
            let elCount = $('.menu-elements__tab-row').find('.menu-elements__tab-group').length
            elCount = 100 / elCount;

            $(".menu-elements__tab-group").each(function () {
                let elHeight = $(this).height();
                elHeight = (elHeight / 2) - 2;
                // $(this).attr({"flex": `1 1 ${elCount}%`, "max-height": `${elCount}%`})
                $(this).css({"--arrow-size": `${elHeight}px`})
            })

            me.#$menuItem.on('mouseover', function () {
                me.#$menuItem.parent().removeClass("js-active");
                const $dataAtt = $(this).data('box');
                if ($(this).parent().is(".menu-item-has-children")) {
                    $(this).parent().addClass("js-active");

                }
                $(".menu-elements__tabRowContent").each(function () {
                    $(this).removeClass("js-active");
                    if ($(this).data("content") === $dataAtt) {
                        $(this).addClass("js-active");
                    }
                })
            });

            $(document).on('click', ".menu-elements__tab-group-wrap", function () {
                $(this).parent().find(".menu-elements__tab-group").removeClass("js-active");

                const $dataAtt = $(this).data('box');
                if ($(this).is(".menu-item-has-children")) {
                    $(this).parent().addClass("js-active");
                }
                $(".menu-elements__tabRowContent").each(function () {
                    $(this).removeClass("js-active");
                    if ($(this).data("content") === $dataAtt) {
                        $(this).addClass("js-active");
                    }
                })
            });

        })
    }

}